"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.SelectedIconWrapper = exports.SectionTitle = exports.SearchInput = exports.ListContainer = exports.List = exports.Item = exports.InputWrapper = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var ListParts = _interopRequireWildcard(require("../Lists/ListParts"));
var _Card = _interopRequireDefault(require("../Containers/Card"));
var _Input = _interopRequireDefault(require("../Inputs/Input"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var InputWrapper = _styledComponents["default"].div.withConfig({
  displayName: "DropdownStyles__InputWrapper",
  componentId: "sc-1ep9wcq-0"
})(["width:100%;"]);
exports.InputWrapper = InputWrapper;
var ListContainer = (0, _styledComponents["default"])(_Card["default"]).attrs(function () {
  return {
    boxShadow: "card",
    borderRadius: "base",
    p: "none"
  };
}).withConfig({
  displayName: "DropdownStyles__ListContainer",
  componentId: "sc-1ep9wcq-1"
})(["z-index:", ";width:", ";overflow-y:auto;overflow-wrap:break-word;max-height:calc(48px * 4);scroll-behavior:smooth;border:1px solid ", ";background-color:", ";&::-webkit-scrollbar{width:5px;background-color:", ";}&::-webkit-scrollbar-thumb{background-color:", ";border-radius:5px;}"], function (props) {
  return props.theme.zIndex.dropdown;
}, function (props) {
  return props.w || "100%";
}, function (props) {
  return props.theme.colors.border;
}, function (props) {
  return props.theme.colors.backgroundPrimary;
}, function (props) {
  return props.theme.colors.transparent;
}, function (props) {
  return props.theme.colors.border;
});
exports.ListContainer = ListContainer;
var List = (0, _styledComponents["default"])(ListParts.List).attrs(function (props) {
  return {
    pH: "s",
    pV: props.variant === "noSeparators" ? "xs" : "s",
    pR: "l",
    separatorVariant: "full",
    separatorColor: props.variant === "noSeparators" ? "transparent" : "border"
  };
}).withConfig({
  displayName: "DropdownStyles__List",
  componentId: "sc-1ep9wcq-2"
})([""]);
exports.List = List;
var Item = (0, _styledComponents["default"])(ListParts.Row).withConfig({
  displayName: "DropdownStyles__Item",
  componentId: "sc-1ep9wcq-3"
})(["cursor:pointer;overflow-wrap:break-word;transition:background-color 100ms;", ";", " > *{pointer-events:none;}"], function (props) {
  return (props.isSelected || props.highlight) && (0, _styledComponents.css)(["background-color:", ";"], props.theme.colors["background".concat(props.highlight ? "Tertiary" : "Secondary")]);
}, function (props) {
  return props.isDisabled && (0, _styledComponents.css)(["cursor:auto;color:", ";background-color:", ";"], props.theme.colors.textSecondary, props.theme.colors.inputBackground);
});
exports.Item = Item;
var SectionTitle = (0, _styledComponents["default"])(Item).withConfig({
  displayName: "DropdownStyles__SectionTitle",
  componentId: "sc-1ep9wcq-4"
})(["background-color:", ";cursor:auto;> span{display:inline-flex;font-weight:", ";}", ""], function (props) {
  return props.theme.colors.backgroundSecondary;
}, function (props) {
  return props.theme.fontWeights.bold;
}, function (props) {
  return props.variant === "noSeparators" && (0, _styledComponents.css)(["background-color:transparent;> span{font-weight:", ";font-size:", ";padding-top:", ";color:", ";}"], props.theme.fontWeights.normal, props.theme.fontSizes.xs, props.theme.spaces.xxs, props.theme.colors.textSecondary);
});
exports.SectionTitle = SectionTitle;
var SelectedIconWrapper = _styledComponents["default"].div.withConfig({
  displayName: "DropdownStyles__SelectedIconWrapper",
  componentId: "sc-1ep9wcq-5"
})(["position:absolute;top:50%;right:calc( ", " / 2 );transform:translate(50%,-50%);line-height:", ";"], function (props) {
  return props.theme.spaces.l;
}, function (props) {
  return props.theme.iconSizes.s;
});
exports.SelectedIconWrapper = SelectedIconWrapper;
var SearchInput = (0, _styledComponents["default"])(_Input["default"]).withConfig({
  displayName: "DropdownStyles__SearchInput",
  componentId: "sc-1ep9wcq-6"
})(["", ";"], function (props) {
  return props.showDropdown && (0, _styledComponents.css)([""]);
});
exports.SearchInput = SearchInput;
var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "DropdownStyles__Wrapper",
  componentId: "sc-1ep9wcq-7"
})(["width:100%;position:relative;", ""], function (props) {
  return props.w && (0, _styledComponents.css)(["width:", ";flex-shrink:0;"], props.w);
});
exports.Wrapper = Wrapper;